import { useState, useMemo } from "react";
import { BillingoPartner } from "../../models/BillingoPartner";

export default function useBillingoPartnerValidation(
    billingoPartner: BillingoPartner,
) {
    const [isValidationEnabled, setIsValidationEnabled] = useState(false);
    const isNameValid = useMemo(() => {
        return billingoPartner.name.trim().length > 0;
    }, [billingoPartner.name, isValidationEnabled]);

    const isCityValid = useMemo(() => {
        return billingoPartner.address.city.trim().length > 0;
    }, [billingoPartner.address.city, isValidationEnabled]);

    const isPostalCodeValid = useMemo(() => {
        return billingoPartner.address.post_code.trim().length > 0;
    }, [billingoPartner.address.post_code, isValidationEnabled]);

    const isAddressValid = useMemo(() => {
        return billingoPartner.address.address.trim().length > 0;
    }, [billingoPartner.address.address, isValidationEnabled]);

    const isBillingInfoValid = useMemo(() => {
        return getBillingInfoValid();
    }, [isAddressValid, isCityValid, isNameValid, isPostalCodeValid]);

    function getBillingInfoValid() {
        return isNameValid && isCityValid && isPostalCodeValid && isAddressValid;
    }

    return {
        isValidationEnabled,
        setIsValidationEnabled,
        isNameValid,
        isCityValid,
        isPostalCodeValid,
        isAddressValid,
        isBillingInfoValid,
        getBillingInfoValid
    }
}